import { parseAsInteger, useQueryState } from 'nuqs';
import { useDeferredValue, useMemo } from 'react';
import { defaultSorting } from '@/features/lot-sizings/hooks/use-lot-sizings-table';
import { getFiltersStateParser, getSortingStateParser } from '@/lib/parsers';
import { useGetLotSizings } from '@/services/apis/queries/lot-sizings/use-get-lot-sizings';
import type { LotSizing } from '@/types/core/lot-sizing/lot-sizing';

export const useLotSizingsQuery = () => {
  const [page] = useQueryState('page', parseAsInteger.withDefault(1));
  const [perPage] = useQueryState('perPage', parseAsInteger.withDefault(10));
  const [sort] = useQueryState(
    'sort',
    getSortingStateParser<LotSizing>().withDefault(defaultSorting),
  );
  const [filters] = useQueryState(
    'filters',
    getFiltersStateParser<LotSizing>().withDefault([]),
  );

  const queryParams = useMemo(
    () => ({ page, perPage, sort, filters }),
    [page, perPage, sort, filters],
  );
  const deferredParams = useDeferredValue(queryParams);
  const isPending = queryParams !== deferredParams;

  const { data: lotSizings } = useGetLotSizings(deferredParams);

  return {
    lotSizings,
    isPending,
  };
};
